import React from "react";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import type RootStackParamList from "../../../navigation/RootStackParamList";
import PostCallView from "../ui/PostCallView";
import {
  postCallExitState,
  postCallScheduleAnotherState,
} from "../postCallNavigation";

type Props = NativeStackScreenProps<RootStackParamList, "PostCall">;

export default function PostCallContainer({ navigation }: Props) {
  // Reset (rebuild) the stack rather than navigate/pop: the call flow leaves a
  // transparentModal (MeetingJoin) under Etiquette/Call/PostCall, and popping
  // across it on iOS leaves the post-call screen swipe-dismissable behind the
  // main screen (#97).
  const handleScheduleAnother = () => {
    navigation.reset(postCallScheduleAnotherState());
  };

  const handleNoThanks = () => {
    navigation.reset(postCallExitState());
  };

  return (
    <PostCallView
      onScheduleAnother={handleScheduleAnother}
      onNoThanks={handleNoThanks}
    />
  );
}
